(function () {
  'use strict';

  var map = window.INNERMON_SPECIES_COMMERCE;

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[character];
    });
  }

  function isEligibleProduct(product) {
    return Boolean(
      product &&
      product.eligible === true &&
      product.published === true &&
      product.available === true &&
      typeof product.species_key === 'string' &&
      (product.product_type === 'species_file_mug' ||
        product.product_type === 'graphic_tee' ||
        product.product_type === 'natural_tote' ||
        product.product_type === 'award_badge') &&
      typeof product.title === 'string' &&
      isNativeProductUrl(product.url)
    );
  }

  function isNativeProductUrl(url) {
    return typeof url === 'string' &&
      url.indexOf('/') === 0 &&
      url.indexOf('//') !== 0 &&
      url.indexOf('\\') === -1 &&
      !/[\u0000-\u001F\s]/.test(url);
  }

  function productsForSpecies(speciesKey) {
    var catalogProducts = Array.isArray(window.INNERMON_CATALOG_PRODUCTS)
      ? window.INNERMON_CATALOG_PRODUCTS
      : Array.isArray(window.INNERMON_LAUNCH_PRODUCTS)
        ? window.INNERMON_LAUNCH_PRODUCTS
      : [];

    return catalogProducts.filter(function (product) {
      return isEligibleProduct(product) && product.species_key === speciesKey;
    });
  }

  function getRecord(key) {
    return map && map.species ? map.species[key] || null : null;
  }

  function ctaLabel(product) {
    return product.product_type === 'species_file_mug' ? 'VIEW MUG' : 'VIEW PRODUCT';
  }

  function productLinkMarkup(product) {
    return '<a class="innermon-commerce-status__link" href="' + escapeHtml(product.url) + '">' +
      escapeHtml(product.title) + ' <span class="innermon-commerce-status__action">' + ctaLabel(product) +
      ' <span aria-hidden="true">↗</span></span></a>';
  }

  function productTypeLabel(product) {
    var labels = {
      species_file_mug: 'MUG',
      graphic_tee: 'GRAPHIC TEE',
      natural_tote: 'NATURAL TOTE',
      award_badge: 'AWARD BADGE'
    };
    return labels[product.product_type] || '';
  }

  function isSafeImageUrl(url) {
    if (typeof url !== 'string' || url.length === 0 || /[\u0000-\u001F\s]/.test(url)) return false;
    return isNativeProductUrl(url) ||
      /^(?:\/\/cdn\.shopify\.com\/|\/\/(?:innermons\.com|rqi0iz-94\.myshopify\.com)\/cdn\/|https:\/\/(?:cdn\.shopify\.com\/|(?:innermons\.com|rqi0iz-94\.myshopify\.com)\/cdn\/))/i.test(url);
  }

  function hasCardData(product) {
    return isEligibleProduct(product) &&
      isSafeImageUrl(product.image_url) &&
      typeof product.image_alt === 'string' && product.image_alt.trim() !== '' &&
      typeof product.price === 'string' && product.price.trim() !== '' &&
      typeof product.price_varies === 'boolean' &&
      productTypeLabel(product) !== '';
  }

  function cardLinkMarkup(product) {
    return '<a class="innermon-species-merch__fallback-link" href="' + escapeHtml(product.url) + '">' +
      escapeHtml(product.title) + ' <span>VIEW PRODUCT <span aria-hidden="true">↗</span></span></a>';
  }

  function quickAddMarkup(product, enabled) {
    if (!enabled || product.product_type === 'graphic_tee' || product.variant_count !== 1 || !Number.isSafeInteger(product.variant_id) || product.variant_id <= 0) return '';
    var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return '<form class="innermon-quick-add" action="' + escapeHtml(rootPath + 'cart/add') + '" method="post" data-innermon-quick-add>' +
      '<input type="hidden" name="id" value="' + product.variant_id + '"><input type="hidden" name="quantity" value="1">' +
      '<button type="submit" aria-label="Add ' + escapeHtml(product.title) + ' to cart">Add to cart</button>' +
      '<p data-quick-add-status role="status" aria-live="polite"></p><a href="' + escapeHtml(rootPath + 'cart') + '" data-quick-add-cart hidden>View cart</a></form>';
  }

  function productCardMarkup(product, record, quickAdd) {
    var price = (product.price_varies ? 'From ' : '') + product.price;
    return '<article class="innermon-species-merch__card" data-product-price="' + (Number.isFinite(product.price_amount) ? product.price_amount : '') + '">' +
      '<a class="innermon-species-merch__image-link" href="' + escapeHtml(product.url) + '" tabindex="-1">' +
        '<img class="innermon-species-merch__image" src="' + escapeHtml(product.image_url) + '" alt="' + escapeHtml(product.image_alt) + '" loading="lazy" width="600" height="600">' +
      '</a>' +
      '<div class="innermon-species-merch__content">' +
        '<p class="innermon-species-merch__type">' + escapeHtml(productTypeLabel(product)) + '</p>' +
        '<h3 class="innermon-species-merch__title">' + escapeHtml(product.title) + '</h3>' +
        '<p class="innermon-species-merch__price">' + escapeHtml(price) + '</p>' +
        '<a class="innermon-species-merch__cta" href="' + escapeHtml(product.url) + '">VIEW PRODUCT <span aria-hidden="true">↗</span></a>' +
        quickAddMarkup(product, quickAdd) +
      '</div>' +
    '</article>';
  }

  function cardsMarkup(record, products, quickAdd) {
    if (!record) return statusMarkup(record, products);

    var eligibleProducts = Array.isArray(products) ? products.filter(function (product) {
      return isEligibleProduct(product) && product.species_key === record.internal_key;
    }) : [];
    if (eligibleProducts.length === 0) return statusMarkup(record, eligibleProducts);

    var cards = eligibleProducts.filter(hasCardData);
    var fallbacks = eligibleProducts.filter(function (product) { return !hasCardData(product); });
    var markup = '<div class="innermon-species-merch__heading">' +
      '<p class="innermon-species-merch__eyebrow">FIELD SUPPLIES</p>' +
      '<h2>For ' + escapeHtml(record.public_name) + '</h2>' +
    '</div>';

    if (cards.length > 0) {
      markup += '<div class="innermon-species-merch__grid">' + cards.map(function (product) {
        return productCardMarkup(product, record, quickAdd);
      }).join('') + '</div>';
    }

    if (fallbacks.length > 0) {
      markup += '<div class="innermon-species-merch__fallbacks">' + fallbacks.map(cardLinkMarkup).join('') + '</div>';
    }

    return markup;
  }

  function statusMarkup(record, products) {
    if (!record) {
      return '<span class="innermon-commerce-status__registry">REGISTRY STATUS: UNDER OBSERVATION</span>' +
        '<span class="innermon-commerce-status__merch">SPECIES FILE: IN THE LAB</span>';
    }

    var eligibleProducts = Array.isArray(products) ? products.filter(function (product) {
      return isEligibleProduct(product) && product.species_key === record.internal_key;
    }) : [];
    var merch = eligibleProducts.length > 0
      ? '<span class="innermon-commerce-status__merch">' + (eligibleProducts.length === 1 ? 'PRODUCT: AVAILABLE' : 'PRODUCTS: AVAILABLE') + '</span>' +
        '<span class="innermon-commerce-status__links">' + eligibleProducts.map(productLinkMarkup).join('') + '</span>'
      : record.launch_collection
        ? '<span class="innermon-commerce-status__merch">SPECIES FILE: PREPARING FOR RELEASE</span>'
        : '<span class="innermon-commerce-status__merch">SPECIES FILE: IN THE LAB</span>';

    return '<span class="innermon-commerce-status__registry">REGISTRY STATUS: DOCUMENTED</span>' + merch;
  }

  function productRelatedStatusMarkup(record, products, currentUrl) {
    if (!record) return statusMarkup(record, products);

    var eligibleProducts = Array.isArray(products) ? products.filter(function (product) {
      return isEligibleProduct(product) && product.species_key === record.internal_key;
    }) : [];
    var relatedProducts = eligibleProducts.filter(function (product) {
      return product.url !== currentUrl;
    });
    var related = relatedProducts.length > 0
      ? '<span class="innermon-commerce-status__merch">RELATED ' + (relatedProducts.length === 1 ? 'PRODUCT' : 'PRODUCTS') + ': AVAILABLE</span>' +
        '<span class="innermon-commerce-status__links">' + relatedProducts.map(productLinkMarkup).join('') + '</span>'
      : '<span class="innermon-commerce-status__merch">CURRENT SPECIES PRODUCT: AVAILABLE</span>';

    return '<span class="innermon-commerce-status__registry">REGISTRY STATUS: DOCUMENTED</span>' + related;
  }

  function hydrateStatusMounts() {
    document.querySelectorAll('[data-innermon-commerce-status]').forEach(function (mount) {
      var record = getRecord(mount.getAttribute('data-commerce-species'));
      var products = record ? productsForSpecies(record.internal_key) : [];
      mount.dataset.productCount = String(products.length);
      var context = mount.getAttribute('data-commerce-context');
      mount.innerHTML = mount.getAttribute('data-commerce-presentation') === 'cards'
        ? cardsMarkup(record, products, context === 'diagnose-result' || context === 'secret-santa')
        : context === 'product-related'
          ? productRelatedStatusMarkup(record, products, mount.getAttribute('data-commerce-current-url'))
          : statusMarkup(record, products);
      if (record) mount.dataset.publicName = record.public_name;
    });
  }

  function hydrateTagContext() {
    var mount = document.querySelector('[data-innermon-tag-context]');
    if (!mount) return;
    var params = new URLSearchParams(window.location.search);
    var key = params.get('species_key') || params.get('species') || '';
    var record = getRecord(key);
    if (!record) return;
    var name = mount.querySelector('[data-tag-context-name]');
    if (name) name.textContent = record.public_name;
    mount.hidden = false;
    mount.dataset.speciesKey = record.internal_key;
    var status = mount.querySelector('[data-tag-context-status]');
    if (status) status.innerHTML = statusMarkup(record, productsForSpecies(record.internal_key));
  }

  function boot() {
    hydrateStatusMounts();
    hydrateTagContext();
  }

  // One request per deliberate click. An uncertain response never auto-retries.
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!form.matches('[data-innermon-quick-add]') || !window.fetch) return;
    event.preventDefault();
    if (form.dataset.pending === 'true') return;
    var button = form.querySelector('button'), status = form.querySelector('[data-quick-add-status]');
    form.dataset.pending = 'true'; button.disabled = true; button.textContent = 'Adding…'; status.textContent = '';
    try {
      var body = new FormData(form);
      body.append('sections', 'cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
      var response = await fetch(form.action + '.js', {method: 'POST', body: body, headers: {Accept: 'application/json'}});
      var result = await response.json();
      if (!response.ok || result.status) {
        status.textContent = typeof result.description === 'string' ? result.description : 'This item could not be added. Please open its product page.';
        button.disabled = false; button.textContent = 'Add to cart';
      } else {
        status.textContent = 'Added to your cart.'; button.textContent = 'Added';
        var icon = document.getElementById('cart-icon-bubble');
        if (icon && result.sections && result.sections['cart-icon-bubble']) {
          var html = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
          var section = html.querySelector('.shopify-section');
          if (section) icon.innerHTML = section.innerHTML;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'innermon-quick-add', cartData: result});
      }
    } catch (error) {
      status.textContent = 'We could not confirm the response. Check your cart before trying again.';
      button.textContent = 'Check cart';
    } finally {
      form.dataset.pending = 'false'; form.querySelector('[data-quick-add-cart]').hidden = false;
    }
  });

  window.innermonCommerceCards = {
    productsForSpecies: productsForSpecies,
    productCard: function (product) { return hasCardData(product) ? productCardMarkup(product, getRecord(product.species_key), true) : ''; }
  };

  window.innermonHydrateCommerce = hydrateStatusMounts;
  if (window.__INNERMON_COMMERCE_TEST__ === true) {
    window.INNERMON_COMMERCE_TEST = {
      isEligibleProduct: isEligibleProduct,
      productsForSpecies: productsForSpecies,
      statusMarkup: statusMarkup,
      productRelatedStatusMarkup: productRelatedStatusMarkup,
      cardsMarkup: cardsMarkup
    };
  }

  if (map && map.species) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }
})();
